import axios from '../utils/axios';

export default function getJobsAnalysis(adminId) {
    return axios.get(`/admin/${adminId}/job-analyis`)
}
